let requestId = 0;

export function getRequesterId() {
    if (requestId > 9000)
        requestId = 1;
    else
        requestId += 1;
    return requestId;
}
